<template>
  <!-- Checklist -->
  <div class="mb-10 mt-6 bg-white rounded-xl p-6 shadow-sm" v-if="hasCheckList">
    <h2 class="mb-4 text-xl font-semibold">Account setup checklist</h2>

    <div class="flex gro mr-2 mb-2" :class="{ 'line-through': item.done }" v-for="(item, i) in items" :key="i">
      <input
        type="checkbox"
        :checked="item.done"
        :disabled="item.done"
        class="w-6 h-6 text-brand-black mb-2 bg-brand-light/10 rounded-[10px] p-3 appearance-none focus:outline-none border border-brand-light focus:border-brand-black focus:border focus:ring-brand-black"
      />
      <p class="ml-2 text-brand-black/70 text-lg whitespace-nowrap">{{ item.label }}</p>
    </div>

    <div class="mt-6">
      <Button
        data-test="login-button"
        label="Complete your profile"
        color="black"
        type="button"
        class="px-3 rounded-xl"
        @click="$router.push('/settings')"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Button from '../TamButton.vue';
import { intNum } from '@/utils/helper';

const store = useStore();

const items = computed(() => {
  const user = store.getters['auth/userDetails'];
  const jobsCount = store.getters['global/getJobsPayload'];
  const subscriptions = store.getters['global/getPayments'] || [];

  return [
    // {
    //   label: 'Your profile information is incomplete',
    //   done: role_title ? true : false,
    // },
    {
      label: `You don't have an active subscription yet`,
      done: subscriptions.filter((item) => item.subscription_status === 'active').length >= 1 ? true : false,
    },
    {
      label: 'You are yet to create a job posting',
      done: intNum(jobsCount?.meta?.total) > 0 ? true : false,
    },
    {
      label: 'You have not added a company logo yet',
      done: user?.logo_url ? true : false,
    },
    {
      label: 'You have added any social link for the company',
      done: user?.social_links.length ? true : false,
    },
    // {
    //   label: 'You have not added a banner image for your job postings',
    //   done: projects?.length ? true : false,
    // },
  ];
});

const hasCheckList = computed(() => {
  if (!items.value.length) {
    return false;
  } else {
    const list = items.value.filter((item) => !item.done);
    return list.length ? true : false;
  }
});
</script>
